import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatSelectFilterModule} from 'mat-select-filter';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DatatablesComponent} from './datatables.component';
import {ChildTemplateComponent} from './child-template.component';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import { default as pjson } from '../../../../../package.json';
import { BrowserModule } from '@angular/platform-browser';
import {HttpClientModule} from '@angular/common/http';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
  declarations: [DatatablesComponent, ChildTemplateComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        MatIconModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatSelectFilterModule,
        BrowserModule,
        HttpClientModule,
        MatButtonModule
    ],
  providers: [DatePipe]
})

export class DatatablesModule {
  constructor(private injector: Injector, private customElementService: CustomElementService) {
    customElementService.convertToCustomElement(DatatablesComponent, 'sc-datatables', this.injector, pjson.version);

  }
}

